import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeCard() {
  return <section className="bg-cream py-[80px] px-6" data-id="element-118">
      <div className="max-w-[680px] mx-auto bg-cream border-2 border-gold rounded-[16px] p-8 md:p-[48px] text-center shadow-sm" data-id="element-119">
        <ShieldCheck className="w-[48px] h-[48px] text-gold mx-auto mb-6" data-id="element-120" />

        <h2 className="font-serif text-navy-800 text-[30px] font-bold mb-5 leading-tight" data-id="element-121">
          Sleep Through The Night — Or It's Free
        </h2>

        <div className="font-sans text-body text-[16px] leading-[1.8] max-w-[500px] mx-auto space-y-4" data-id="element-122">
          <p data-id="element-123">
            Try The 11PM Spine Reset for 60 full days. Use the protocol. Use the
            bonuses. Follow the routine for one week.
          </p>
          <p data-id="element-124">
            If you don't feel like something has genuinely shifted — contact us
            and every cent comes back.
          </p>
          <p data-id="element-125">
            No forms. No interrogation. No waiting. Just a clean, fast refund.
            You have nothing to lose. And the bonuses are yours to keep either
            way.
          </p>
        </div>

        <div className="border-t border-dashed border-gold pt-5 mt-7" data-id="element-126">
          <p className="text-teal-500 font-bold text-[14px] uppercase tracking-widest" data-id="element-127">
            60-Day Money Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}